import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df13412"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "P-Abs W-100 H-100 BG2 Rad2 ItemBacground",
  style: {"z-index":"-2"}
}, null, -1))
const _hoisted_2 = { class: "CatalogItemData" }
const _hoisted_3 = { class: "D-Flex M-Auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.OpenImage())),
    class: _normalizeClass(["Shadow1 Rad2 P-Rel CookiesFade Pointer", 'CatalogItemCard_' + _ctx.ViewType])
  }, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "CatalogItemImage Rad3",
        style: _normalizeStyle('background-image: url(' + _ctx.DefaultImageHandler(_ctx.CatalogItemData?.ImgUrl ? _ctx.CatalogItemData?.ImgUrl : '') + ');')
      }, [
        (_ctx.ViewType === 'GRID')
          ? (_openBlock(), _createBlock(_component_CookiesIcon, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Deselect())),
              class: _normalizeClass([_ctx.Selected ? '' : 'D-None', "SQR2em CookiesFade Shadow1 F1_5em"]),
              ID: ('Done' as IconsIDs)
            }, null, 8, ["class", "ID"]))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.CatalogItemData?.Code), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.PreventDefault && _ctx.PreventDefault(...args))),
      class: "CatalogItemCardButtons D-Flex Rad2 Shadow0",
      style: {"cursor":"default"}
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CookiesIcon, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Selected ? _ctx.$emit('DeSelected', _ctx.CatalogItemData) : _ctx.$emit('Selected', _ctx.CatalogItemData))),
          style: _normalizeStyle(_ctx.Selected && _ctx.ViewType === 'GRID' ? 'transform: rotate(45deg);' : ''),
          class: "SQR2em Pointer Transition0_25 F1_5em",
          Tooltip: _ctx.Translate('Select'),
          ID: (_ctx.Selected && _ctx.ViewType === 'Tiles' ? 'Done' : 'Add' as IconsIDs),
          Color: ({ ColorMain: (_ctx.$store.getters.CurrentTheme === 'light' ? _ctx.Theme.Light2 : _ctx.Theme.Shade3), ColorSecond: _ctx.Theme.Shade0 } as IconColor)
        }, null, 8, ["style", "Tooltip", "ID", "Color"])
      ])
    ])
  ], 2))
}